/** Presentation mode, not installation intent or a launch query parameter. */
export const isInstalledAppRuntime = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true ||
    ['standalone', 'fullscreen'].some((mode) =>
      window.matchMedia?.(`(display-mode: ${mode})`)?.matches === true
    )
  );
};
